<template>
    <div id="app">
        <b-row class="navibar">
          <b-col md="12">
            <nav-bar />
          </b-col>
            <b-col md="12" class="text-center mb-1">
                <h1>District Forms</h1>
            </b-col>
        </b-row>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
</template>

<script>
import { setApiData } from './services/api.js';
import NavBar from './components/NavBar.vue';

  export default {
    name: 'App',
    components: {
      NavBar
    },
    props: {
      'siteHomeUrl': String,
      'apiUrl': String,
      'nonce': String
    },
    data() {
      return {
        transitionName: 'slide-left',
      };
    },
    // then, in the parent component,
    // watch the `$route` to determine the transition to use
    watch: {
      '$route' (to, from) {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      }
    },
    created() {
      if (this.siteHomeUrl && this.apiUrl && this.nonce) {
        setApiData(this.siteHomeUrl, this.apiUrl, this.nonce);
      }
    }
  }
</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.logo{
  width: 3%;
  height: auto;
}

.router-link-active {
  color: red;
}
/* it applys to all row classes inside a form that's inside a container class */
/* the parent of the form has to ba a container class */
.container form .row {
  text-align: left;
}
.navibar {
  /* Full-screen */
  height: auto;
  /* Center the background image */
  background-position: center;
  /* Scale and zoom in the image */
  background-size: cover;
  /* Add position: relative to enable absolutely positioned elements inside the image (place text) */
  position: relative;
  /* Add a white text color to all elements inside the .bgimg container */
  color: rgb(255, 255, 255);
  /* Add a font */
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /* Set the font-size to 25 pixels */
  font-size: 20px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

html{width:100%;}
</style>
